<template>
  <div class="notice-container">
    <div class="header">
      <h2>网点机构管理</h2>
      <a style="color: red;" target="_blank" href="https://api.map.baidu.com/lbsapi/getpoint/index.html">百度拾取坐标系统（获取经纬度）</a>
      <el-button type="primary" @click="handleAdd">
        <i class="el-icon-plus"></i> 添加网点
      </el-button>
    </div>

    <!-- 公告列表 -->
    <el-table :data="cityList" border style="width: 100%" max-height="600px" v-loading="loading">
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column prop="name" label="分行名称"></el-table-column>
      <el-table-column prop="department" label="管理部门" width="160">
      </el-table-column>
      <el-table-column prop="address" label="网点地址" width="240">
      </el-table-column>
      <el-table-column prop="longitude,latitude" label="网点坐标（经纬度）" width="240">
        <template slot-scope="scope">
          （{{ scope.row.longitude }} , {{scope.row.latitude}}）
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="联系方式" width="140">
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="update_time"
        label="更新时间"
        width="180"
      ></el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 添加/编辑公告对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%">
      <el-form
        :model="noticeForm"
        :rules="rules"
        ref="noticeForm"
        label-width="80px"
      >
        <el-form-item label="名称" prop="title">
          <el-input
            v-model="noticeForm.name"
            placeholder="请输入网点名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门" prop="title">
          <el-input
            v-model="noticeForm.department"
            placeholder="请输入管理部门"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="title">
          <el-input
            v-model="noticeForm.phone"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="办公地址" prop="title">
          <el-input
            v-model="noticeForm.address"
            placeholder="请输入办公地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="经度" prop="title">
          <el-input
            v-model="noticeForm.longitude"
            placeholder="请输入坐标经度"
          ></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="title">
          <el-input
            v-model="noticeForm.latitude"
            placeholder="请输入坐标纬度"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getInfo, addInfo, editInfo, delInfo } from "@/api";
export default {
  name: "Notice",
  data() {
    return {
      loading: false, // 加载状态
      cityList: [], // 网点列表数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      total: 0, // 总记录数
      dialogVisible: false, // 对话框显示状态
      dialogTitle: "添加网点", // 对话框标题
      editId: "", // 编辑时的网点ID
      // 表单数据对象
      noticeForm: {
        name: "", // 网点名称
        department: "", // 管理部门
        address: "", // 办公地址
        phone: "", // 联系电话
        longitude:"", //经度
        latitude:"",//纬度
      },
      // 表单验证规则
      rules: {
        name: [
          { required: true, message: "请输入网点名称", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
        department: [
          { required: true, message: "请输入管理部门", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "长度在 2 到 50 个字符",
            trigger: "blur",
          },
        ],
        phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        address: [
          { required: true, message: "请输入办公地址", trigger: "blur" },
        ],
        longitude: [
          { required: true, message: "请输入坐标经度", trigger: "blur" },
        ],
        latitude: [
          { required: true, message: "请输入坐标纬度", trigger: "blur" },
        ],
      },
    };
  },
  // 组件创建时执行
  created() {
    this.getCityList(); // 获取网点列表数据
  },
  methods: {
    // 获取网点列表数据
    getCityList() {
      this.loading = true; // 显示加载状态
      // 调用API接口获取数据
      getInfo({
        model: "city", // 模型名称
        condition: {}, // 查询条件
        page: this.currentPage, // 当前页码
        pagesize: this.pageSize, // 每页条数
      }).then((res) => {
        if (res.status == 200) {
          this.cityList = res.data.data; // 设置网点列表数据
          this.total = res.data.page_info.total_size; // 设置总记录数
          this.loading = false; // 隐藏加载状态
        }
      });
    },

    // 添加网点
    handleAdd() {
      this.editId = ""; // 清空编辑ID
      this.dialogTitle = "添加网点"; // 设置对话框标题
      // 重置表单数据
      this.noticeForm = {
        name: "",
        department: "",
        phone: "",
        address: "",
        longitude:"", 
        latitude:"",
      };
      this.dialogVisible = true; // 显示对话框
    },

    // 编辑网点
    handleEdit(row) {
      this.editId = row._id; // 设置编辑ID
      this.dialogTitle = "编辑网点"; // 设置对话框标题
      this.noticeForm = { ...row }; // 复制行数据到表单
      this.dialogVisible = true; // 显示对话框
    },

    // 删除网点
    handleDelete(row) {
      // 显示确认对话框
      this.$confirm("确认删除该公告?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.editId = row._id; // 设置要删除的ID
          // 调用删除API
          delInfo({
            model: "city", // 模型名称
            _id: this.editId, // 要删除的ID
          }).then((res) => {
            if (res.status == 200) {
              this.$message.success("删除成功"); // 显示成功消息
              this.getCityList(); // 重新获取列表数据
            }
          });
        })
        .catch(() => {}); // 用户取消删除时不做处理
    },

    // 提交表单
    submitForm() {
      // 表单验证
      this.$refs.noticeForm.validate((valid) => {
        if (valid) {
          // 根据是否有editId判断是编辑还是新增
          if (this.editId) {
            // 编辑现有网点
            editInfo({
              model: "city", // 模型名称
              condition: {}, // 查询条件
              _id: this.editId, // 要编辑的ID
              data: {
                ...this.noticeForm, // 表单数据
              },
            }).then((res) => {
              if (res.status == 200) {
                this.$message.success(this.dialogTitle + "成功"); // 显示成功消息
                this.dialogVisible = false; // 关闭对话框
                this.currentPage == 1; // 注意：这里应该是赋值操作 =，而不是比较操作 ==
                this.getCityList(); // 重新获取列表数据
              }
            });
          } else {
            // 添加新网点
            addInfo({
              model: "city", // 模型名称
              condition: {}, // 查询条件
              data: {
                ...this.noticeForm, // 表单数据
              },
            }).then((res) => {
              if (res.status == 200) {
                this.$message.success(this.dialogTitle + "成功"); // 显示成功消息
                this.dialogVisible = false; // 关闭对话框
                this.currentPage = 1; // 重置为第一页
                this.getCityList(); // 重新获取列表数据
              }
            });
          }
        }
      });
    },

    // 每页显示条数变化时的处理函数
    handleSizeChange(val) {
      this.pageSize = val; // 更新每页显示条数
      this.getCityList(); // 重新获取列表数据
    },
    // 当前页变化时的处理函数
    handleCurrentChange(val) {
      this.currentPage = val; // 更新当前页码
      this.getCityList(); // 重新获取列表数据
    },
  },
};
</script>

<style scoped>
.notice-container {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.el-tag {
  min-width: 60px;
  text-align: center;
}
</style>